<template>
    <div class="update-qwilr-data-source">
      <h3>Update Definition</h3>
      <div class="form-group mb-4">
        <label for="data-source-name" class="form-label">Data Source Name</label>
        <input
          type="text"
          id="data-source-name"
          class="form-control"
          v-model="dataSourceName"
          placeholder="Enter data source name"
      />
      </div>
      <div class="form-group mb-4">
        <label for="provider" class="form-label">Provider</label>
        <select 
            id="provider"
            class="form-select shadow-none fw-semibold rounded-0"
            v-model="selectedProviderId"
            >
            <option value="">Select a provider</option>
            <option 
                v-for="(provider, index) in providers" 
                :key="index" 
                :value="provider.id"
            >
            {{ provider.name }}
            </option>
        </select>
      </div>
      <div class="form-group mb-4">
        <label for="connection-string" class="form-label">Connection String</label>
        <input
          type="text"
          id="connection-string"
          class="form-control"
          placeholder="Enter connection string"
          v-model="connectionString"
      />
      </div>
      <div class="form-buttons">
        <button class="btn btn-primary" @click="updateDataSource" :disabled="isBusy">
          <div v-if="isBusy">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>

              Loading...
          </div>
          <div v-else>
            Update Data Source
          </div>
        </button>
        <button class="btn btn-secondary" @click="$emit('close')">Cancel</button>
      </div>
    </div>
  </template>
  
  <script>
  import { UpdateQwilrDataSource } from '@/core/services/entities/qwilr.service'
  import { useToast } from 'vue-toastification'
  import { Provider} from "@/core/constant/QwilrDataSourceProvider";

  export default{
    name:"UpdateQwilrDataSource",
    props:{
        dataSource:{
            type:Object,
            required:true
        }
    },
    data(){
        return{
            dataSourceName:'',
            selectedProviderId:0,
            connectionString:'',
            isBusy:false,
            providers:[
                {id:Provider.MySql, name:'MySql'}
            ]
        }
    },
    methods:{
        async updateDataSource(){
            this.isBusy = true;

            setTimeout(async () => {
              if (!this.validateFields()) {
                this.isBusy = false;
                return;
              }

              const toast = useToast();
              const payload = { 
                id:this.dataSource.id, 
                dataSourceName:this.dataSourceName,
                provider:(Number)(this.selectedProviderId), 
                connectionString:this.connectionString
            };
          
              await UpdateQwilrDataSource(payload)
                      .then(response => {
                      if (response.status === 200) {
                          toast.success('Data source updated successfully!', {
                          timeout: 2000
                          })
                          this.isBusy = false;
                          this.$emit('dataSourceUpdated'); // Emit the event to notify the parent component
                          this.$emit('close'); // Close the lightbox after adding data stream
                      }
                      })
                      .catch(ex => {
                          this.isBusy = false;
                          const errorMessage = ex.response?.data || ex.message || "An unknown error occurred";
                          console.log(ex);
                          toast.error(`Failed to update data source : ${errorMessage}`, {timeout: 2000,});
                      })
            }, 500);

        },
        validateFields() {
          const toast = useToast();

          if (this.dataSourceName.trim() === '') {
            toast.error('Data source name is required!', { timeout: 3000 });
            return false; 
          }

          if (this.selectedProviderId<=0) {
            toast.error('Provider name is required!', { timeout: 3000 });
            return false; 
          }

          if (this.connectionString.trim() === '') {
            toast.error('Connection string is required!', { timeout: 3000 });
            return false; 
          }

          return true; 
        }
    },
    created() {
        this.dataSourceName=this.dataSource.dataSourceName
        this.selectedProviderId=this.dataSource.provider
        this.connectionString=this.dataSource.connectionString
    }
  }
 </script>
  
  <style scoped>
  .update-qwilr-data-source {
    width: 600px; /* Double the size */
    height: 500px; /* Double the size */
    padding: 40px; /* Increase padding */
    background-color: #fff; /* Ensure background is white */
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }
  
  .form-group {
    margin-bottom: 1rem;
  }
  
  .form-label {
    display: block;
    margin-bottom: 0.5rem;
  }
  
  .form-control {
    width: 100%;
    padding: 0.5rem;
    margin-bottom: 0.5rem;
  }
  
  .form-buttons {
    display: flex;
    justify-content: space-between;
    margin-top: 1rem;
  }
  
  .btn {
    padding: 0.5rem 1rem;
  }
  
  .btn-secondary {
    background-color: #6c757d;
    color: #fff;
  }
  
  .btn-secondary:hover {
    background-color: #5a6268;
  }
  </style>
  